import { Box, Grid, Stack, Typography, Item } from "@mui/material";
import React from "react";
import { motion }  from "framer-motion";
import useStyles from "../components/MainTitle";



function About() {
  const classes = useStyles()
  return (
    <>
      <Box sx={{paddingBottom: {xs: "120px", md: "100px"}, overflowX: "hidden"}}>
        <Stack direction="row">
          <Box className={classes.BigTitle}>
          <motion.div initial={{opacity: 0, y: 50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}} >Know me</motion.div>
            <Box className={classes.SmallTitle}>
              <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}}>
                ABOUT
                <Box className={classes.afterClass} />
              </motion.div>
            </Box>
          </Box>
        </Stack>
        <Grid container sx={{transform: {xs: "translateY(40px)", md: "translateY(70px)"} }}>
          <Grid item xs={12} md={7} lg={8}>
            <Box  sx={{marginRight: {xs: "10px", sm: "15px", md: "30px"}}}>
              <motion.div initial={{opacity: 0, y: -100}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1}}}>
                <Typography sx={{fontSize: {xs: "1.8rem", md: "2rem"} , fontWeight: 600}}>
                  I'm<Typography sx={{fontSize: {xs:"1.8rem", sm: "2.2rem"}, fontWeight: 600}}  color="primary" component={"span"}> Mohamad Hamsho</Typography>, Web Developer
                </Typography>
              </motion.div>
              <motion.div initial={{opacity: 0, y: 100}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay:1.2}}}>
                <Typography sx={{textAlign: "justify", lineHeight: "1.9"}}>
                I have a proven track record of delivering high-quality, responsive websites and applications that meet the needs of both businesses and users, I have a deep understanding of the latest technologies and trends in front-end development, and I always stay ahead of the curve to deliver cutting-edge solutions. I bring a unique combination of technical expertise, creativity, and problem-solving skills to every project, ensuring that every solution I deliver is tailored to the needs of my clients.
                I am a true front-end development specialist, constantly pushing the boundaries of what is possible to create exceptional user experiences.
                </Typography>
              </motion.div>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} lg={4}>
            <Box sx={{marginTop: "30px", overflow: "hidden"}}>
              <Box sx={{margin : {xs : "0px 10px 10px 0", md: "0px 10px 10px"} }}>
                <motion.div initial={{opacity: 0, x: 150}} animate={{opacity: 1, x: 0, transition: {duration: .5, delay:1.4}}} >
                  <Typography className={classes.aboutBox}>Name: <Typography color="grey.main" component={"span"}>Mohamad Hamsho</Typography>
                  </Typography>
                </motion.div>
              </Box>
              <Box sx={{margin : {xs : "0px 20px 10px 0", md: "0px 20px 10px"} }}>
              <motion.div initial={{opacity: 0, x: -150}} animate={{opacity: 1, x: 0, transition: {duration: .5, delay:1.6}}} >
                  <Typography className={classes.aboutBox}>Email:: <Typography color="primary.main" component={"span"}>nostalgiedamour2013@gmail.com</Typography>
                  </Typography>
                </motion.div>
              </Box>
              <Box sx={{margin : {xs : "0px 20px 10px 0", md: "0px 20px 10px"} }}>
              <motion.div initial={{opacity: 0, x: 150}} animate={{opacity: 1, x: 0, transition: {duration: .5, delay:1.8}}} >
                  <Typography className={classes.aboutBox}>Age: <Typography color="grey.main" component={"span"}>34 years old</Typography>
                  </Typography>
                </motion.div>
              </Box>
              <Box sx={{margin : {xs : "0px 20px 10px 0", md: "0px 20px 10px"} }}>
                <motion.div initial={{opacity: 0, x: -150}} animate={{opacity: 1, x: 0, transition: {duration: .5, delay:2}}} >
                  <Typography className={classes.aboutBox}>From: <Typography color="grey.main" component={"span"}>Istanbul, Turkey</Typography>
                  </Typography>
                </motion.div>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Stack sx={{transform: {xs: "translateY(60px)", md: "translateY(70px)"}}}>
          <motion.div initial={{opacity: 0, x: "-200"}} animate={{opacity: 1, x: 0, transition: {duration: .5, delay: 2.2}}}>
            <Typography 
            sx={{fontSize: "1.6rem", fontWeight: "600", margin: "30px 0 10px"}} component={"h3"}>
              My Skills:
            </Typography>
          </motion.div>
          <Grid container >
            <Grid item xs={12} md={6}>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
                <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 2.4}}}>
                  <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>HTML/CSS</Typography>
                    <Typography>94%</Typography>
                  </Box>
                  <Box className={classes.progressBar}>
                    <Box style={{width: "94%"}} className={classes.bar}></Box>
                  </Box>
                </motion.div>
              </Box>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
                <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 2.6}}}>
                  <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>JavaScript</Typography>
                    <Typography>87%</Typography>
                  </Box>
                  <Box className={classes.progressBar}>
                    <Box style={{width: "87%"}} className={classes.bar}></Box>
                  </Box>
                </motion.div>
              </Box>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
                <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 2.8}}}>
                  <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>SASS</Typography>
                    <Typography>74%</Typography>
                  </Box>
                  <Box className={classes.progressBar}>
                    <Box style={{width: "74%"}} className={classes.bar}></Box>
                  </Box>
                </motion.div>
              </Box>
          </Grid>
          <Grid item xs={12} md={6}>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
              <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 3}}}>
                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <Typography>Bootstrap</Typography>
                  <Typography>91%</Typography>
                </Box>
                <Box className={classes.progressBar}>
                  <Box style={{width: "91%"}} className={classes.bar}></Box>
                </Box>
              </motion.div>
              </Box>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
                <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 3.2}}}>
                  <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>React JS</Typography>
                    <Typography>89%</Typography>
                  </Box>
                  <Box className={classes.progressBar}>
                    <Box style={{width: "89%"}} className={classes.bar}></Box>
                  </Box>
                </motion.div>
              </Box>
              <Box sx={{marginBottom: "30px", paddingRight: {xs: "15px", md: "20px", lg: "40px"}}}>
                <motion.div initial={{opacity: 0, scale: -3}} animate={{opacity: 1, scale: 1, transition: {duration: .5, delay: 3.4}}}>
                  <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>Web Design</Typography>
                    <Typography>97%</Typography>
                  </Box>
                  <Box className={classes.progressBar}>
                    <Box style={{width: "97%"}} className={classes.bar}></Box>
                  </Box>
                </motion.div>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </>
  );
}

export default About;
